import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { API_COMMON_CACHE_TIME } from '@/utils/consts'
import { SelectOptionType } from '@/components/content/SelectBoxTypes'
import { getInventoryWarehouses, getIvlInventoryEnabled, getIvlInventoryStatuses } from './ivlApis'
import { IvlInventoryRequest, IvlInventoryResult } from './ivlTypes'

const PATH = ['inventory', 'inventoryStatus', 'IVL'] as const
export const ivlInventoryQueryKeys = {
  mode: [...PATH, 'MODE'] as const,
  list: (params: IvlInventoryRequest | null) => [...PATH, 'LIST', params] as const,
  warehouses: [...PATH, 'WAREHOUSES'] as const,
}

export const useIvlInventoryEnabled = (): UseQueryResult<boolean, Error> => useQuery({
  queryKey: ivlInventoryQueryKeys.mode,
  queryFn: getIvlInventoryEnabled,
  staleTime: 0,
  refetchOnMount: 'always',
  retry: false,
  meta: { noErrorMessage: true },
})

/** 조건별 캐시를 사용하고 이전 페이지를 새 조건의 결과로 표시하지 않는다. */
export const useGetIvlInventoryStatuses = (params: IvlInventoryRequest | null): UseQueryResult<IvlInventoryResult, Error> => useQuery({
  queryKey: ivlInventoryQueryKeys.list(params),
  queryFn: ({ signal }) => {
    if (!params) throw new Error('재고 조회 조건이 없어요.')
    return getIvlInventoryStatuses(params, signal)
  },
  enabled: params !== null,
  staleTime: 0,
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  meta: { noErrorMessage: true },
})

export const useGetInventoryWarehouseOptions = (enabled: boolean): UseQueryResult<SelectOptionType<string>[], Error> => useQuery({
  queryKey: ivlInventoryQueryKeys.warehouses,
  queryFn: async () => {
    const response = await getInventoryWarehouses()
    return response.data.items.map(({ warehouseCode, warehouseName }) => ({
      value: warehouseCode,
      label: `${warehouseName} (${warehouseCode})`,
    })).sort((a, b) => a.label.localeCompare(b.label, 'ko', { numeric: true }))
  },
  enabled,
  staleTime: API_COMMON_CACHE_TIME,
  meta: { noErrorMessage: true },
})
